import { render, staticRenderFns } from "./crowded.vue?vue&type=template&id=5a63e99f&scoped=true&"
import script from "./crowded.vue?vue&type=script&lang=js&"
export * from "./crowded.vue?vue&type=script&lang=js&"
import style0 from "./crowded.vue?vue&type=style&index=0&id=5a63e99f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a63e99f",
  null
  
)

export default component.exports